import { call, put } from 'redux-saga/effects';
import { HIDE_SPINNER, SHOW_SPINNER } from '../../redux/modules/spinner/spinner';
import { retriable } from '../retriable';
import {
    didApiCallFailDueToUnauthorizedUser, didApiCallFailDueToVersionMismatch,
    getErrorMessage,
    isValidFunction,
    isValidNumber,
} from '../../constants/CommonUtil';
import { MISMATCH_IN_VERSION, SESSION_TIMEOUT } from '../../redux/modules/login/login-actions';
import { ERROR_MESSAGE, SUCCESS_MESSAGE } from '../../redux/modules/message/message-actions';
import messages from '../../constants/messages';
import {
    GENERIC_ADD_OR_UPDATE_FAILURE,
    GENERIC_ADD_OR_UPDATE_SUCCESS,
    GENERIC_FETCH_FAILURE,
    GENERIC_FETCH_SUCCESS,
} from '../../redux/modules/genericMastersRedux/genericMaster-actions';
import { getStringFromObject } from '../../constants/lodashUtils';

/**
 * Created by sachinprakash on 12/8/19.
 */
export const config = {
    headers: { 'Content-Type': 'application/json' },
};

export function* constructFetchGenericMastersPagesWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(retriable().post, action.api, action.searchConstruct, config);
        yield put({
            type: GENERIC_FETCH_SUCCESS,
            data: response.data,
            filters: action.filters,
            sortCol: action.sortCol,
            sortOrder: action.sortOrder,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        // do error action
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: `${messages.GENERIC.FETCH_FAILED}: ${getErrorMessage(e)}`,
            });
        }
        yield put({ type: GENERIC_FETCH_FAILURE });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export function* fetchGenericMastersPagesWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const response = yield call(retriable().get, action.api);
        yield put({
            type: GENERIC_FETCH_SUCCESS,
            data: response.data,
            filters: action.filters,
            sortCol: action.sortCol,
            sortOrder: action.sortOrder,
        });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    } catch (e) {
        // do error action
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: `${messages.GENERIC.FETCH_FAILED}: ${getErrorMessage(e)}`,
            });
        }
        yield put({ type: GENERIC_FETCH_FAILURE });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}

export function* genericAddOrUpdateWorker(action) {
    try {
        yield put({ type: SHOW_SPINNER, state: { canShow: true } });
        const { payload, api } = action;
        let apiWithParam = api;
        if (isValidNumber(getStringFromObject('id', payload, undefined))) {
            apiWithParam = `${api}/${getStringFromObject('id', payload, null)}`;
        }
        let response = {};
        if (isValidNumber(getStringFromObject('id', payload, undefined))) {
            response = yield call(retriable().put, apiWithParam, payload, config);
        } else response = yield call(retriable().post, apiWithParam, payload, config);
        yield put({
            type: GENERIC_ADD_OR_UPDATE_SUCCESS,
            data: response.data,
        });
        if (isValidFunction(action.successCallBack)) {
            action.successCallBack();
        }
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
        yield put({
            type: SUCCESS_MESSAGE,
            message: messages.GENERIC.ADD_OR_UPDATE_SUCCESS,
        });
    } catch (e) {
        // do error action
        if (isValidFunction(action.failureCallBack)) {
            action.failureCallBack();
        }
        if (didApiCallFailDueToUnauthorizedUser(e)) {
            yield put({ type: SESSION_TIMEOUT, actionToDispatchAfterLogin: action });
        } else if (didApiCallFailDueToVersionMismatch(e)) {
            yield put({ type: MISMATCH_IN_VERSION });
        } else {
            yield put({
                type: ERROR_MESSAGE,
                message: `${messages.GENERIC.ADD_OR_UPDATE_FAILED}: ${getErrorMessage(e)}`,
            });
        }
        yield put({ type: GENERIC_ADD_OR_UPDATE_FAILURE });
        yield put({ type: HIDE_SPINNER, state: { canShow: false } });
    }
}
